// 경과 시간 계산 (startAt부터 현재까지) - MM:SS 형식
export const calculateElapsedTime = (startAt: string): string => {
  const start = new Date(startAt);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - start.getTime()) / 1000);

  const hours = Math.floor(diffInSeconds / 3600);
  const minutes = Math.floor((diffInSeconds % 3600) / 60);
  const seconds = diffInSeconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

// 남은 시간 포맷 (MM:SS)
export const formatRemainingTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

// YYYY-MM-DD HH:mm:ss를 상대 시간으로 변환 (예: 2시간 전)
export const formatRelativeTime = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diff = now.getTime() - date.getTime();

  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (minutes < 60) {
    return `${minutes}분 전`;
  } else if (hours < 24) {
    return `${hours}시간 전`;
  } else {
    return `${days}일 전`;
  }
};

// 오늘 날짜 (한국 시간 기준, YYYY-MM-DD)
export const getTodayDate = (): string => {
  const today = new Date();
  const koreaTime = new Date(today.getTime() + (9 * 60 * 60 * 1000));
  return koreaTime.toISOString().split('T')[0];
};

// 어제 날짜 (한국 시간 기준, YYYY-MM-DD)
export const getYesterdayDate = (): string => {
  const today = new Date();
  const yesterday = new Date(today.getTime() - (24 * 60 * 60 * 1000));
  const koreaTime = new Date(yesterday.getTime() + (9 * 60 * 60 * 1000));
  return koreaTime.toISOString().split('T')[0];
};
